import styled from 'styled-components';
export const DocumentViewButtonsWrapper = styled.div `
  display: ${(props) => (props.isTapped ? 'block' : 'none')};
  .Buttons {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    width: 100%;
    height: 40px;
    max-width: 420px;
    background-color: rgba(83, 85, 92, 0.8);
    border-radius: 2px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #fff;
    font-size: ${(props) => props.theme.fontXXSmall};
  }

  .Buttons .page-input {
    width: 27px;
    margin-left: 10px;
    background-color: rgba(0, 0, 0, 0.1);
    border: 0.75px solid #fff;
    -moz-appearance: textfield;
    color: #fff;
    height: 20px;
  }

  .Buttons .page-number {
    margin-right: 10px;
  }

  .Buttons .page-zoom {
    width: 29px;
    display: inline-block;
  }

  .Buttons input::-webkit-outer-spin-button,
  .Buttons input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  .Buttons button,
  .DocumentView .Buttons a {
    color: #fff;
    border: 0;
    background: none;
    cursor: pointer;
  }

  .Buttons button:hover,
  .DocumentView .Buttons a:hover {
    color: #fff;
  }

  .Buttons .buttons-group-tooltip {
    background-color: #272932;
    opacity: 1;
    font-size: ${(props) => props.theme.fontXXXSmall};
    padding: 8px;
  }
  /* Canvas */
  canvas {
    transition: width 0.08s;
  }

  /* DD menu */
  .dd-menu-items {
    font-size: ${(props) => props.theme.fontXXSmall};
    min-width: 290px;
    width: 90%;
    text-align: left;
  }
  .dd-menu .dd-menu-items.dd-items-upwards {
    margin: 0 0 1.5em;
  }

  .dd-menu-items .dd-items-left::after {
    content: '';
    border-right: 10px solid rgba(113, 59, 59, 0);
    border-top: 10px solid rgba(39, 41, 50, 0.95);
    border-left: 10px solid rgba(0, 128, 0, 0);
    position: absolute;
    margin-left: 135px;
  }

  .dd-menu-icon {
    margin-right: 7px;
    vertical-align: sub;
  }

  .dd-menu-icon-small {
    width: 16px;
  }

  .dd-menu-header {
    border-bottom: 1px solid #fff;
    background-color: #272932;
  }

  .dd-menu-subheader {
    text-transform: uppercase;
    font-size: ${(props) => props.theme.fontXXXSmall};
    font-weight: ${(props) => props.theme.bold};
  }

  .dd-menu-header-icon {
    float: right;
    cursor: pointer;
  }
  .dd-menu-items .dd-menu-header img {
    width: 9.72px;
  }
  .dd-menu .dd-menu-items ul li > *:not(.dd-item-ignore),
  .dd-menu-header,
  .dd-menu-subheader {
    color: #dadada;
    padding: 10px;
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .dd-menu .dd-menu-items ul li:hover:not([role='separator']):not(.separator),
  .DocumentView .dd-menu .dd-menu-items ul li > *:focus {
    color: #dadada;
    background-color: rgba(39, 41, 50, 0);
  }
  .dd-menu-items .dd-items-left {
    background-color: rgba(39, 41, 50, 0.95);
  }
  .dd-menu .separator {
    height: 1px;
    background-color: #fff;
  }

  /* responsive */
  @media (max-width: 575px) {
    .Buttons {
      bottom: 0;
    }
    .Buttons .buttons-group {
      margin: 0;
    }
    .dd-menu {
      position: static;
    }
    .dd-menu-items .dd-items-left::after {
      right: 20px;
    }
  }
  @media (min-width: 992px) {
    display: block;
  }
`;
